import { Controller } from '@hotwired/stimulus'

// Address typeahead for the travel-hotels destination field, backed by the AWS
// Location Service via /api/location_suggestions.json (the same endpoint the
// retail H4H hotel search uses). The chosen text is submitted with the search
// form; the controller geocodes it to lat/lng server-side.
export default class extends Controller {
  static targets = ['input', 'suggestions']

  connect() {
    this.debounceTimer = null
    this.onOutsideClick = this.onOutsideClick.bind(this)
    document.addEventListener('click', this.onOutsideClick)
  }

  disconnect() {
    clearTimeout(this.debounceTimer)
    document.removeEventListener('click', this.onOutsideClick)
  }

  search() {
    clearTimeout(this.debounceTimer)
    const text = this.inputTarget.value.trim()
    if (text.length < 3) {
      this.clear()
      return
    }
    this.debounceTimer = setTimeout(() => this.fetchSuggestions(text), 250)
  }

  fetchSuggestions(text) {
    fetch(`/api/location_suggestions.json?text=${encodeURIComponent(text)}`, {
      headers: { Accept: 'application/json' },
    })
      .then(response => (response.ok ? response.json() : []))
      .then(places => this.render(places))
      .catch(() => this.clear())
  }

  render(places) {
    this.clear()
    places.forEach(place => {
      const item = document.createElement('li')
      item.className = 'list-group-item list-group-item-action'
      item.textContent = place.text
      item.addEventListener('click', () => this.select(place.text))
      this.suggestionsTarget.appendChild(item)
    })
  }

  select(text) {
    this.inputTarget.value = text
    this.clear()
  }

  clear() {
    this.suggestionsTarget.innerHTML = ''
  }

  onOutsideClick(event) {
    if (!this.element.contains(event.target)) this.clear()
  }
}
